// src/components/admin/FooterSettings.jsx (مكون جديد)

import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaWhatsapp, FaEnvelope, FaPhone, FaMapMarkerAlt } from 'react-icons/fa';

const API_URL = "https://one-stop.ps/api/footer-settings"; // عدل هذا الرابط

const FooterSettings = () => {
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState('');

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            const response = await axios.get(API_URL, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setSettings(response.data);
            setLoading(false);
        } catch (error) {
            console.error('Failed to fetch settings:', error);
            setMessage('فشل في جلب الإعدادات. يرجى التحقق من اتصال الشبكة.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSettings();
    }, []);

    const handleChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setMessage('');

        try {
            const token = localStorage.getItem('token');
            await axios.post(API_URL, settings, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setMessage('✅ تم حفظ إعدادات التذييل بنجاح!');
            setSaving(false);
        } catch (error) {
            console.error('Failed to save settings:', error);
            setMessage('❌ فشل في حفظ الإعدادات. تحقق من البيانات المدخلة.');
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="text-center py-10 text-xl font-semibold">جاري تحميل إعدادات التذييل...</div>;
    }

    // مكون مساعد لحقل الإدخال
    const InputField = ({ label, name, icon, type = 'text', rtl = false }) => (
        <div className="mb-4">
            <label htmlFor={name} className="block text-gray-700 font-medium mb-2 flex items-center gap-2" dir="rtl">
                {icon} {label}
            </label>
            <input
                type={type}
                id={name}
                name={name}
                value={settings[name] || ''}
                onChange={handleChange}
                className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-blue-500/50 transition-all duration-200 ${rtl ? 'text-right' : 'text-left'}`}
                dir={rtl ? 'rtl' : 'ltr'}
            />
        </div>
    );

    // مكون مساعد لحقل المنطقة النصية (للوصف)
    const TextAreaField = ({ label, name, rtl = false }) => (
        <div className="mb-4">
            <label htmlFor={name} className="block text-gray-700 font-medium mb-2" dir="rtl">
                {label}
            </label>
            <textarea
                id={name}
                name={name}
                rows="4"
                value={settings[name] || ''}
                onChange={handleChange}
                className={`w-full p-3 border border-gray-300 rounded-lg focus:ring-4 focus:ring-blue-500/50 transition-all duration-200 ${rtl ? 'text-right' : 'text-left'}`}
                dir={rtl ? 'rtl' : 'ltr'}
            />
        </div>
    );


    return (
        <div className="bg-white p-6 rounded-xl shadow-lg" dir="rtl">
            <h1 className="text-3xl font-bold mb-6 text-[#07396a] border-b pb-4">إدارة محتوى التذييل (Footer)</h1>
            
            {message && (
                <div className={`p-3 mb-4 rounded-lg ${message.startsWith('✅') ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                    {message}
                </div>
            )}

            <form onSubmit={handleSubmit}>
                
                {/* قسم الوصف */}
                <h2 className="text-2xl font-semibold mb-4 mt-6 text-[#218A7A]">وصف الشركة ({settings.key})</h2>
                <div className="grid md:grid-cols-2 gap-4 border p-4 rounded-lg mb-6 bg-gray-50">
                    <TextAreaField label="الوصف (اللغة العربية - footer_description_ar)" name="footer_description_ar" rtl={true} />
                    <TextAreaField label="الوصف (اللغة الإنجليزية - footer_description_en)" name="footer_description_en" rtl={false} />
                </div>

                {/* قسم معلومات الاتصال */}
                <h2 className="text-2xl font-semibold mb-4 mt-6 text-[#218A7A]">معلومات الاتصال</h2>
                <div className="grid md:grid-cols-2 gap-4 border p-4 rounded-lg mb-6 bg-gray-50">
                    <InputField label="البريد الإلكتروني (contact_email)" name="contact_email" type="email" icon={<FaEnvelope />} />
                    <InputField label="رقم الهاتف (contact_phone)" name="contact_phone" icon={<FaPhone />} />
                    <InputField label="العنوان (اللغة العربية - contact_address_ar)" name="contact_address_ar" icon={<FaMapMarkerAlt />} rtl={true} />
                    <InputField label="العنوان (اللغة الإنجليزية - contact_address_en)" name="contact_address_en" icon={<FaMapMarkerAlt />} rtl={false} />
                </div>

                {/* قسم وسائل التواصل الاجتماعي */}
                <h2 className="text-2xl font-semibold mb-4 mt-6 text-[#218A7A]">روابط التواصل الاجتماعي</h2>
                <div className="grid md:grid-cols-2 gap-4 border p-4 rounded-lg mb-6 bg-gray-50">
                    <InputField label="رابط فيسبوك (social_facebook)" name="social_facebook" icon={<FaFacebook />} />
                    <InputField label="رابط إنستغرام (social_instagram)" name="social_instagram" icon={<FaInstagram />} />
                    <InputField label="رابط لينكدإن (social_linkedin)" name="social_linkedin" icon={<FaLinkedin />} />
                    <InputField label="رابط تيك توك (social_tiktok)" name="social_tiktok" icon={<FaTiktok />} />
                    <InputField label="رابط واتساب (social_whatsapp)" name="social_whatsapp" icon={<FaWhatsapp />} />
                </div>
                
                <button
                    type="submit"
                    className="w-full py-3 px-4 bg-[#07396a] text-white font-bold rounded-lg hover:bg-[#052a4d] transition-colors duration-300 disabled:bg-gray-400"
                    disabled={saving}
                >
                    {saving ? 'جاري الحفظ...' : 'حفظ التغييرات'}
                </button>
            </form>
        </div>
    );
};

export default FooterSettings;